<div class="tw-h-full tw-w-full">
  <div class="tw-justify-center tw-items-center tw-h-full tw-w-full tw-flex">
    <mat-card
      class="tw-w-4/5 tw-max-w-xl tw-justify-center tw-items-center tw-m-auto matp-raised-card"
    >
      <!-- ヘッダー -->
      <div class="!matp-bg-primary tw-h-20 tw-w-full tw-text-center">
        <img
          src="assets/img/macnicaTracks_Logo_RGB_white.png"
          alt="ロゴ"
          class="tw-h-full tw-max-w-full"
        />
      </div>

      <!-- コンテンツ -->
      <main class="tw-w-full tw-p-4 tw-justify-center tw-items-center">
        <router-outlet />
      </main>
    </mat-card>
  </div>
</div>
